module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zm-9 8a3.001 3.001 0 0 1 0 6 3.001 3.001 0 0 1 0-6zm5 17a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-8c0-.552.316-1.316.708-1.708l2.586-2.586a1 1 0 0 1 1.414 0L18 20l3.292-3.292a1 1 0 0 1 1.414 0l2.586 2.586c.392.39.708 1.154.708 1.706v4z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/image-1.js
// module id = 1180
// module chunks = 14